const SEND_TEXT_BY_OPTION = {
  a: 'create xl sheet',
  b: 'create doc',
  c: 'create app',
}

export function resolveAgentQuestionOptionSendText(optionId, freeText = '') {
  if (optionId === 'd') return freeText.trim()
  return SEND_TEXT_BY_OPTION[optionId] || ''
}
